import { isObject } from 'lodash';
import { ModalTemplateProps } from '../components/ModalTemplate';
import { DialogBaseProps } from '../types';

export type ConfirmResult = {
  rememberAction?: boolean | undefined;
  confirmed: boolean;
};

export const isConfirmResult = (result: unknown): result is ConfirmResult =>
  isObject(result) &&
  'confirmed' in result &&
  typeof (result as any).confirmed === 'boolean';

export type ConfirmConfig = DialogBaseProps<ConfirmResult> &
  Pick<ModalTemplateProps, 'inputDataTestId'> & {
    cancelButtonTitle?: string;
    cancelButtonClickId?: string;
    cancelButtonDataTestId?: string;
  };

export type ConfirmWithYesInputConfig = ConfirmConfig & {
  yesInputLabel?: string;
};

export type ConfirmDialogProps = ConfirmConfig & {
  onConfirm: (result: ConfirmResult) => void;
  onCancel: () => void;
};

export type ConfirmWithYesInputDialogProps = ConfirmWithYesInputConfig & {
  onConfirm: (result: ConfirmResult) => void;
  onCancel: () => void;
};

export type AlertConfig = DialogBaseProps<false>;

export type InfoConfig = Omit<
  DialogBaseProps<false>,
  | 'confirmButtonTitle'
  | 'confirmButtonClickId'
  | 'confirmButtonDataTestId'
  | 'isConfirmButtonDanger'
  | 'showRememberActionCheckbox'
  | 'rememberActionCustomCheckboxText'
> &
  Pick<
    ModalTemplateProps,
    | 'primaryButtonText'
    | 'primaryButtonClickId'
    | 'onPrimaryButtonClick'
    | 'primaryButtonDataTestId'
    | 'fixedHeight'
  >;
